<template>
  <!-- <div> -->
  <v-toolbar id="subheader"
             flat
             app
             fixed
             height=30>

    <from-to-date-selector class="filterDates"
                           @on-dates-selected="onDatesSelected"></from-to-date-selector>
  </v-toolbar>
  <!-- <v-progress-linear v-if="isLoading"
                       slot="progress"
                       color="blue"
                       indeterminate></v-progress-linear>
  </div> -->
</template>

<script>
import FromDateSelector from '@/components/commons/FromToDateSelector.vue';

export default {
  name: 'dps-subheader',
  components: { [FromDateSelector.name]: FromDateSelector },
  props: ['isLoading'],
  data() {
    return {
      dates: []
    };
  },
  methods: {
    onDatesSelected(dates) {
      if (typeof dates === 'undefined') {
        if (this.dates.length === 0) {
          return;
        }
      } else {
        this.dates = dates;
      }

      this.$emit('on-dates-selected', { dates: this.dates });
    }
  }
};
</script>

<style lang="scss" scoped>
#subheader {
  margin-top: 64px !important;
  z-index: 1;
  background-color: #f5f5f5;
}
</style>

<style lang="scss">
.container.fluid.grid-list-md {
  margin-top: 30px !important;
}
</style>




// WEBPACK FOOTER //
// src/components/commons/Subheader.vue